module.exports = __webpack_public_path__ + "img/upskill_logo.c91d7c5e.png";